import { CognitiveSearchResultModel, ReportSearchModel } from '@/types';
import { buildAPIUrl, responseInterceptor, toQueryString } from '.';

export const getReportMatchesByPage = async (filterRequest: {
  userId: string;
  pageNum: number;
  pageSize: number;
}): Promise<CognitiveSearchResultModel<ReportSearchModel>> => {
  const response = await responseInterceptor(
    await fetch(
      `${await buildAPIUrl()}/umbraco/Api/StylusSubscriptionApi/GetReportMatchesByPage${toQueryString(filterRequest)}`,
    ),
  );

  return response.json();
};
